import React from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import { type EmailTemplateHtmlPreviewType, useEmailTemplateHtmlPreviewQuery } from '@dashboard/generated/wp/platform';
import { Box } from '@mui/material';

import ScaledBox from '../ScaledBox';

type Props = {
  id: string;
  type: EmailTemplateHtmlPreviewType;
};
export default function TemplateThumbnailPreview({ id, type }: Props) {
  const { data } = useEmailTemplateHtmlPreviewQuery({ variables: { id, type } });
  const htmlString = data?.EmailTemplateHtmlPreview;

  if (htmlString === undefined) {
    return (
      <Box sx={{ height: '100%', overflow: 'hidden', position: 'relative' }}>
        <LoadingIndicator />
      </Box>
    );
  }

  if (htmlString === null) {
    return (
      <Box sx={{ height: '100%', overflow: 'hidden', position: 'relative' }}>
        <p>There were errors rendering this template preview.</p>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100%', overflow: 'hidden', position: 'relative' }}>
      <ScaledBox>
        <iframe
          title="Thumbnail Preview"
          srcDoc={htmlString}
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </ScaledBox>
      <Box sx={{ top: 0, bottom: 0, left: 0, right: 0, position: 'absolute' }} />
    </Box>
  );
}
